import { createFileRoute } from '@tanstack/react-router'

import { RedeemablesOverview } from '@/components/Redeem/RedeemablesOverview'
import { withStaticTitle } from '@/utils/withTitle'

export const Route = createFileRoute('/_app/redeem/')({
  component: RedeemPage,
  head: withStaticTitle('Redeemables'),
})

function RedeemPage() {
  return <RedeemablesOverview />
}
